import * as types from './constants'

const initialState = {
	rewards: [],
	searchValue: '',
	searchValueOnClick: '',
	overlayIsShowing: false,
	rewardName: '',
	selectedCourses: [],
	rewardsLoaded: false,
	currentReward: null,
	editOverlayIsShowing: false,
	coursesWithPoints: [],
}

const rewardReducer = (state = initialState, action) => {
	switch (action.type) {
		case types.SET_REWARD_NAME:
			return {
				...state,
				rewardName: action.value,
			}
		case types.SELECT_COURSES:
			return {
				...state,
				selectedCourses: action.courses,
			}
		case types.SET_REWARDS:
			return {
				...state,
				rewards: action.rewards,
			}
		case types.SET_REWARDS_BY_ID:
			return {
				...state,
				currentReward: action.currentReward,
			}
		case types.SET_SEARCH_VALUE:
			return {
				...state,
				searchValue: action.searchValue,
			}
		case types.SET_SEARCH_VALUE_ON_CLICK:
			return {
				...state,
				searchValueOnClick: action.value,
			}
		case types.TOGGLE_OVERLAY:
			return {
				...state,
				overlayIsShowing: !state.overlayIsShowing,
			}
		case types.TOGGLE_EDIT_OVERLAY:
			return {
				...state,
				editOverlayIsShowing: !state.editOverlayIsShowing,
			}
		case types.SET_REWARDS_LOADED:
			return {
				...state,
				rewardsLoaded: action.value,
			}
		case types.SET_CURRENT_REWARD:
			return {
				...state,
				currentReward: action.value,
			}
		case types.SET_CURENT_REWARD_NAME:
			return {
				...state,
				currentReward: {
					...state.currentReward,
					name: action.value,
				},
			}
		case types.SET_COURSES_WITH_POINTS:
			return {
				...state,
				coursesWithPoints: action.courses,
			}
		default:
			return state
	}
}

export default rewardReducer
